import { Component, Input, OnInit, ViewChild } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { BanService } from "app/service/ban.service";
import { CheckMatAutoService } from "app/service/check-mat-auto.service";
import { debounceTime, tap, switchMap, finalize } from "rxjs/operators";
import {
  DateAdapter,
  MAT_DATE_FORMATS,
  MAT_DATE_LOCALE,
} from "@angular/material/core";
import { MomentDateAdapter } from "@angular/material-moment-adapter";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { MatTableDataSource } from "@angular/material/table";
import { InscriptionService } from "app/service/inscription.service";
import { ToastrService } from "ngx-toastr";
import { ActivatedRoute, Router } from "@angular/router";
import { AuthService } from "app/service/auth/auth.service";
import { NgxSpinnerService } from "ngx-spinner";
import emailMask from "text-mask-addons/dist/emailMask";
import { FileUploader } from "ng2-file-upload";
import * as moment from "moment";
import { environment } from "environments/environment";
import { MatStepper } from "@angular/material/stepper";
import Swal from "sweetalert2";

export const MY_FORMATS = {
  parse: {
    dateInput: "DD/MM/YYYY",
  },
  display: {
    dateInput: "DD/MM/YYYY",
    monthYearLabel: "MMM YYYY",
    dateA11yLabel: "LL",
    monthYearA11yLabel: "MMMM YYYY",
  },
};

@Component({
  selector: "app-inscription-add",
  templateUrl: "./inscription-add.component.html",
  styleUrls: ["./inscription-add.component.css"],
  providers: [
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE],
    },
    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
    BanService,
    CheckMatAutoService,
  ],
})
export class InscriptionAddComponent implements OnInit {
  @ViewChild("stepper") stepper: MatStepper;
  telmask = [
    /0/,
    /[1-9]/,
    "-",
    /[0-9]/,
    /[0-9]/,
    "-",
    /[0-9]/,
    /[0-9]/,
    "-",
    /[0-9]/,
    /[0-9]/,
    "-",
    /[0-9]/,
    /[0-9]/,
  ];
  emailMaskHtml = emailMask;
  personneFormGroup: FormGroup;
  accompagnantFormGroup: FormGroup;
  coupleFormGroup: FormGroup;
  filteredAdresses: any[] = [];
  selectCPForAdresse = "";
  isLoadingAdresse = false;
  selectedAdresse = "";
  civilites = [{ value: "Monsieur" }, { value: "Madame" }];
  typesAccompagnement = [
    { value: "Seul(e)" },
    { value: "En couple" },
    { value: "Avec un aidant ou accompagnant" },
    { value: "Avec un accompagnant professionnel" },
  ];
  isWait = false;
  dataSource = new MatTableDataSource([]);
  userInformation: any;
  phraseCheckExistAdresse =
    "Si vous ne trouvez pas votre adresse dans le moteur de recherche précédent merci de cliquer ici";
  checkNoFindAdresse = false;
  existAdresse = true; // remettre à true une fois le moteur de recherche de nouveau en place cf soucis du 141025
  // isMoteurRechercheOut = true; // à supprimer une fois moteur de recherche en place 141025
  isSelectedAdresse = false;
  selectedCheque = false;
  existCoupleInscription = false;
  existAccompagnantInscription = false;
  calculTarif = 0;
  // URL = 'http://localhost:3009/inscription/load';
  URL =
    environment.protocol + "://" + environment.hostName + "/inscription/load";
  isLoadJustificatif = false;
  justificatifDomicile = null;
  maxDateDemandeur: Date;
  uploader: FileUploader = new FileUploader({
    url: this.URL,
    itemAlias: "file",
    queueLimit: 1,
    maxFileSize: 7 * 1024 * 1024,
    // authToken: "Bearer " + this.authService.userValue.token
  });
  @Input() isVisiteur = true;
  checkTarifSocialCouple = false;
  checkTarifSocialSeul = false;
  isPreinscriptionEnvoyee = false;

  constructor(
    private formBuilder: FormBuilder,
    private bas: BanService,
    private modalService: NgbModal,
    private toastr: ToastrService,
    private inscriptionService: InscriptionService,
    private router: Router,
    private authService: AuthService,
    private spinner: NgxSpinnerService,
    private route: ActivatedRoute,
  ) {}

  moteurRechercheOut() {
    this.isSelectedAdresse = true;
    this.personneFormGroup.get("adresseManuelle").setValue("");
    this.personneFormGroup.controls["adresseManuelle"].setValidators([
      Validators.required,
    ]);
    this.personneFormGroup.controls["adresseManuelle"].updateValueAndValidity();
    this.personneFormGroup.controls["adresse"].clearValidators();
    this.personneFormGroup.controls["adresse"].updateValueAndValidity();
  }

  async ngOnInit() {
    this.route.params.subscribe(async (params) => {
      if (params.type === "admin") {
        this.isVisiteur = false;
      }
    });
    // Pour participer, le demandeur doit avoir 70 ans au plus tard le 31/12/2026
    const dateReference = moment("31/12/2026", "DD/MM/YYYY");
    const dateNaissanceMax = dateReference.clone().subtract(70, "years");

    this.maxDateDemandeur = dateNaissanceMax.toDate();
    // this.userInformation = this.authService.getTokenDecode();
    this.personneFormGroup = this.formBuilder.group({
      civilite: ["", [Validators.required]],
      lastName: ["", [Validators.required]],
      firstName: ["", [Validators.required]],
      dateNaissance: ["", [Validators.required]],
      mail: ["", [, Validators.email]],
      telephone: [
        "",
        Validators.compose([
          Validators.pattern(
            "^[0-9]{2}[-]?[0-9]{2}[-]?[0-9]{2}[-]?[0-9]{2}[-]?[0-9]{2}$",
          ),
        ]),
      ],
      adresse: [
        { value: "" /*disabled: true*/ },
        Validators.compose([
          Validators.required,
          CheckMatAutoService.valueSelected(this.filteredAdresses),
        ]),
      ],
      adresseManuelle: [""],
      typeAccompagnement: ["", [Validators.required]],
      choixListeDiffusion: ["", [Validators.required]],
      choixPhoto: ["", [Validators.required]],
    });
    this.coupleFormGroup = this.formBuilder.group({
      civilite: ["", [Validators.required]],
      lastName: ["", [Validators.required]],
      firstName: ["", [Validators.required]],
      dateNaissance: ["", [Validators.required]],
      choixListeDiffusion: ["", [Validators.required]],
      choixPhoto: ["", [Validators.required]],
    });
    this.accompagnantFormGroup = this.formBuilder.group({
      civilite: ["", [Validators.required]],
      lastName: ["", [Validators.required]],
      firstName: ["", [Validators.required]],
      dateNaissance: ["", [Validators.required]],
      mail: ["", [Validators.email]],
      telephone: [
        "",
        Validators.compose([
          Validators.pattern(
            "^[0-9]{2}[-]?[0-9]{2}[-]?[0-9]{2}[-]?[0-9]{2}[-]?[0-9]{2}$",
          ),
        ]),
      ],
      choixListeDiffusion: ["", [Validators.required]],
      choixPhoto: ["", [Validators.required]],
    });

    // Fonction pour mat autocomplete Adresse
    this.personneFormGroup
      .get("adresse")
      .valueChanges.pipe(
        debounceTime(300),
        tap(() => (this.isLoadingAdresse = true)),
        switchMap((value) =>
          this.bas
            .searchAdresse({
              filterQuery: value,
              filterPostcode: "53000" /*this.selectCPForAdresse*/,
            })
            .pipe(finalize(() => (this.isLoadingAdresse = false))),
        ),
      )
      .subscribe((adresses) => (this.filteredAdresses = adresses));

    // Fonction pour l'upload des pièces jointes
    this.uploader.onAfterAddingFile = (file) => {
      file.withCredentials = false;
    };
    this.uploader.onCompleteItem = (item: any, response: any, status: any) => {
      if (status === 200) {
        this.spinner.hide("spinner_initial");
        this.modalService.dismissAll();
        const addFile = {
          fileName: JSON.parse(response).fileName,
          location: JSON.parse(response).fileLocation,
        };
        this.justificatifDomicile = addFile;
        this.isLoadJustificatif = true;
        this.clearUploader();
      } else {
        this.spinner.hide("spinner_initial");
      }
    };
    // this.moteurRechercheOut(); // à supprimer quand moteur de recherche ok
  } // fin ng on init

  uploadJustificatif() {
    this.inscriptionService
      .viewPJ(this.justificatifDomicile.location)
      .subscribe((response: any) => {
        const file = response.file;
        const linkFile = `data:file;base64,${file}`;
        const downloadLink = document.createElement("a");
        const fileName = this.justificatifDomicile.fileName;
        downloadLink.href = linkFile;
        downloadLink.download = fileName;
        downloadLink.click();
      });
  }

  deleteJustificatif() {
    this.spinner.show("spinner_initial");
    this.inscriptionService
      .deleteJustificatif(this.justificatifDomicile.location)
      .subscribe((response: any) => {
        if (response.success === "file deleted") {
          this.justificatifDomicile = null;
          this.isLoadJustificatif = false;
        } else {
          this.spinner.hide("spinner_initial");
        }
      });
    this.clearUploader();
  }

  clearUploader() {
    while (this.uploader.queue.length) {
      this.uploader.queue[0].remove();
    }
    this.uploader.progress = 0;
  }

  uploadFile() {
    this.spinner.show("spinner_initial");
  }

  openModal(modalUploadFile) {
    this.modalService
      .open(modalUploadFile, {
        ariaLabelledBy: "modal-basic-title",
        size: "lg",
      })
      .result.then(
        (result) => {
          // this.closeResult = `Closed with: ${result}`;
        },
        (reason) => {
          // this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
        },
      );
  }

  isExistAdresse(event) {
    this.existAdresse = !event.checked;
    this.phraseCheckExistAdresse = !event.checked
      ? "Si vous ne trouvez pas votre adresse dans le moteur de recherche précédent merci de cliquer ici"
      : "Décocher pour revenir au moteur de recherche de l'adresse;";
    if (!event.checked) {
      this.isSelectedAdresse = false;
      this.personneFormGroup.get("adresseManuelle").setValue("");
      this.personneFormGroup.controls["adresseManuelle"].clearValidators();
      this.personneFormGroup.controls[
        "adresseManuelle"
      ].updateValueAndValidity();
      this.personneFormGroup.get("adresse").setValue("");
      this.personneFormGroup.controls["adresse"].setValidators(
        Validators.compose([
          Validators.required,
          CheckMatAutoService.valueSelected([]),
        ]),
      );
      this.personneFormGroup.controls["adresse"].updateValueAndValidity();
      this.personneFormGroup.get("adresse").enable();
    } else {
      // ne trouve pas avec moteur de recherche
      this.isSelectedAdresse = true;
      this.personneFormGroup.get("adresseManuelle").setValue("");
      this.personneFormGroup.controls["adresseManuelle"].setValidators([
        Validators.required,
      ]);
      this.personneFormGroup.controls[
        "adresseManuelle"
      ].updateValueAndValidity();
      this.personneFormGroup.get("adresse").setValue("");
      this.personneFormGroup.controls["adresse"].clearValidators();
      this.personneFormGroup.controls["adresse"].updateValueAndValidity();
    }
  }

  displayAdresse(adresse: any) {
    if (adresse) {
      return adresse.libelle;
    }
  }

  getAdresse() {
    this.personneFormGroup.get("adresse").disable();
    this.isSelectedAdresse = true;
  }

  resetAdresse() {
    this.personneFormGroup.get("adresse").setValue("");
    this.personneFormGroup.get("adresse").enable();
    this.isSelectedAdresse = false;
  }

  changeTypeAccompagnement(event) {
    if (event.value === "En couple") {
      this.existCoupleInscription = true;
      this.existAccompagnantInscription = false;

      this.accompagnantFormGroup.reset();
    } else if (
      event.value === "Avec un aidant ou accompagnant" ||
      event.value === "Avec un accompagnant professionnel"
    ) {
      this.existCoupleInscription = false;
      this.existAccompagnantInscription = true;

      this.coupleFormGroup.reset();
    } else {
      this.existCoupleInscription = false;
      this.existAccompagnantInscription = false;

      this.coupleFormGroup.reset();
      this.accompagnantFormGroup.reset();
    }
  }

  addInscription() {
    if (
      this.personneFormGroup.controls.mail.value === "" &&
      this.personneFormGroup.controls.telephone.value === ""
    ) {
      this.toastr.warning(
        "Vous devez renseigner au moins un contact (mail ou téléphone)",
      );
    } else {
      // this.spinner.show();
      const dataSend = {
        civiliteDemandeur: this.personneFormGroup.controls.civilite.value,
        firstNameDemandeur: this.personneFormGroup.controls.firstName.value,
        lastNameDemandeur: this.personneFormGroup.controls.lastName.value,
        dateNaissanceDemandeur:
          this.personneFormGroup.controls.dateNaissance.value,
        mailDemandeur: this.personneFormGroup.controls.mail.value,
        telephoneDemandeur: this.personneFormGroup.controls.telephone.value,
        adresseDemandeur: this.personneFormGroup.controls.adresse.value.libelle,
        adresseManuelleDemandeur:
          this.personneFormGroup.controls.adresseManuelle.value,
        existAdresseDemandeur: this.existAdresse,
        typeAccompagnementDemandeur:
          this.personneFormGroup.controls.typeAccompagnement.value,
        priceDemandeur: "6€",
        choixListeDiffusionDemandeur:
          this.personneFormGroup.controls.choixListeDiffusion.value,
        choixPhotoDemandeur: this.personneFormGroup.controls.choixPhoto.value,
        existJustificatif: this.justificatifDomicile !== null ? true : false,
        justificatifFileName:
          this.justificatifDomicile !== null
            ? this.justificatifDomicile.fileName
            : "",
        justificatifLocation:
          this.justificatifDomicile !== null
            ? this.justificatifDomicile.location
            : "",
        checkTarifSocialSeul: this.checkTarifSocialSeul,
        civiliteCouple: this.coupleFormGroup.controls.civilite.value,
        firstNameCouple: this.coupleFormGroup.controls.firstName.value,
        lastNameCouple: this.coupleFormGroup.controls.lastName.value,
        dateNaissanceCouple: this.coupleFormGroup.controls.dateNaissance.value,
        mailCouple: this.personneFormGroup.controls.mail.value,
        telephoneCouple: this.personneFormGroup.controls.telephone.value,
        priceCouple:
          this.personneFormGroup.controls.typeAccompagnement.value ===
          "En couple"
            ? "6€"
            : null,
        choixListeDiffusionCouple:
          this.coupleFormGroup.controls.choixListeDiffusion.value,
        choixPhotoCouple: this.coupleFormGroup.controls.choixPhoto.value,
        checkTarifSocialCouple: this.checkTarifSocialCouple,
        civiliteAccompagnant:
          this.accompagnantFormGroup.controls.civilite.value,
        firstNameAccompagnant:
          this.accompagnantFormGroup.controls.firstName.value,
        lastNameAccompagnant:
          this.accompagnantFormGroup.controls.lastName.value,
        dateNaissanceAccompagnant:
          this.accompagnantFormGroup.controls.dateNaissance.value,
        mailAccompagnant: this.accompagnantFormGroup.controls.mail.value,
        telephoneAccompagnant:
          this.accompagnantFormGroup.controls.telephone.value,
        priceAccompagnant: "6€",
        choixListeDiffusionAccompagnant:
          this.accompagnantFormGroup.controls.choixListeDiffusion.value,
        choixPhotoAccompagnant:
          this.accompagnantFormGroup.controls.choixPhoto.value,
        canal: this.isVisiteur ? "en ligne" : "sur place",
      };
      this.inscriptionService
        .addInscription(dataSend)
        .subscribe((response: any) => {
          if (response.Inscription === "Inscription in added successfully") {
            if (!this.isVisiteur) {
              this.isWait = false;
              this.spinner.hide();
              Swal.fire({
                title: "Félicitations!",
                icon: "success",
                html:
                  "Votre préinscription a bien été enregistrée!<br /><br />" +
                  "<span style='text-decoration: underline;'>Rappel</span><br /><br />" +
                  "Vous avez un délai de 5 jours pour valider définitivement votre inscription en transmettant votre règlement à l'Espace Seniors Intergénérationnel 90 rue de Rennes 53000 Laval.",
              });
              this.router.navigate(["/inscription/list"]);
            } else {
              /*this.stepper.selectedIndex = 0;
            this.existAdresse = true;
            this.checkNoFindAdresse = false;
            this.resetAdresse();
            this.existCoupleInscription = false;
            this.existAccompagnantInscription = false;
            this.personneFormGroup.reset();
            this.accompagnantFormGroup.reset();
            this.coupleFormGroup.reset(); */
              this.isWait = false;
              this.spinner.hide();
              this.isPreinscriptionEnvoyee = true;
              Swal.fire({
                title: "Félicitations!",
                icon: "success",
                html:
                  "Votre préinscription a bien été enregistrée!<br /><br />" +
                  "<span style='text-decoration: underline;'>Rappel</span><br /><br />" +
                  "Vous avez un délai de 5 jours pour valider définitivement votre inscription en transmettant votre règlement à l'Espace Seniors Intergénérationnel 90 rue de Rennes 53000 Laval.",
              });
            }
          } else {
            this.isWait = false;
            this.spinner.hide();
            this.toastr.warning("Le serveur a rencontré un problème");
          }
        });
    }
  } // fin addInscription
}
